import { UserSettingStore } from './store'
export * from './store'

export const userSettingStore = UserSettingStore.new()
export { UserSettingStore } from './store'
